import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { CardBackground } from './components/CardBackground';

const StyledCard = styled('div')(({ theme }) => ({
  borderRadius: theme.radius.innerSurface,
  background: theme.colors.background.primary,
  boxShadow: theme.shadows.primary,
  padding: `${theme.spacing * 4}px ${theme.spacing * 4}px`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  overflow: 'hidden',
  gap: theme.spacing * 3,
  position: 'relative',
  zIndex: 1,
  flex: 1,
  minHeight: 150,
  cursor: 'pointer',
  transition: '.3s all',
  height: '100%',
}));

export type CardProps = {
  warning?: boolean;
  disabled?: boolean;
  hovered?: boolean;
  active?: boolean;
  image?: ReactNode;
  children?: ReactNode;
};

export const Card = ({
  warning,
  disabled,
  hovered,
  image,
  active,
  children,
}: CardProps) => {
  return (
    <StyledCard>
      <CardBackground
        image={image}
        disabled={disabled}
        hovered={hovered}
        warning={warning}
        active={active}
      />
      {children}
    </StyledCard>
  );
};
